import React from 'react'

import * as Dialog from '@radix-ui/react-dialog'

import Address from '../../base/Address'
import ShipmentDetail from '../../base/ShipmentDetail'
import StatusBadge from '../../base/StatusBadge'
import useTranslation from '../../context/hooks/useTranslation'
import formatDate from '../../lib/utils/formatDate'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import {
  selectMorningScanState,
  setActiveShipmentDetails,
} from '../../redux/MorningScan'
import CloseIcon from '../../vectors/CloseIcon'

export const ShipmentDetailsDialog: React.FC = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const { activeShipmentDetails } = useAppSelector(selectMorningScanState)

  const closeDialog = () => {
    dispatch(setActiveShipmentDetails(undefined))
  }

  return (
    <Dialog.Root open={Boolean(activeShipmentDetails)}>
      <Dialog.Portal>
        <Dialog.Overlay
          onClick={closeDialog}
          className="bg-indigo-scrim fixed inset-0 opacity-60"
        />
        <Dialog.Content className="animate-fade-up shadow-elevation-2 fixed inset-0 m-auto h-[400px] w-[600px] rounded-md bg-white px-8 py-4 text-indigo-50">
          <Dialog.Title className="font-heading text-h3 mb-8">
            {t('RETURNS_SCAN.DETAILS.SHIPMENT_DETAILS')}
          </Dialog.Title>
          <Dialog.Close
            onClick={closeDialog}
            className="hover:bg-gray-34 absolute right-4 top-4 outline-1 focus:outline-indigo-50"
          >
            <CloseIcon />
          </Dialog.Close>

          {activeShipmentDetails && (
            <div className="flex flex-col">
              <ShipmentDetail label={t('RETURNS_SCAN.TRUNKRS_NR')}>
                {activeShipmentDetails.trunkrsNr}
              </ShipmentDetail>
              <ShipmentDetail label={t('RETURNS_SCAN.ADDRESS')}>
                <Address
                  address={activeShipmentDetails.address}
                  city={activeShipmentDetails.city}
                  country={activeShipmentDetails.country}
                  postalCode={activeShipmentDetails.postalCode}
                />
              </ShipmentDetail>
              <ShipmentDetail
                label={t('RETURNS_SCAN.DETAILS.INTENDED_DELIVERY_DATE')}
              >
                {activeShipmentDetails.intendedDeliveryDate}
              </ShipmentDetail>
              <ShipmentDetail label={t('IN_SINCE')}>
                {formatDate(new Date(activeShipmentDetails.inSince))}
              </ShipmentDetail>
              <ShipmentDetail label={t('HUB_INVENTORY.STATUS')}>
                <StatusBadge status={activeShipmentDetails.latestState} />
              </ShipmentDetail>
            </div>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ShipmentDetailsDialog
